<template>
  <div>
    <div id="toolbar">
      <slot name="tooltip" v-if="$slots.tooltip"></slot>
      <template v-else>
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
        <button class="ql-underline"></button>
        <button class="ql-strike"></button>
        <button class="ql-blockquote"></button>
        <button class="ql-code-block"></button>
        <button class="ql-header" value="1"></button>
        <button class="ql-header" value="2"></button>
        <button class="ql-list" value="ordered"></button>
        <button class="ql-list" value="bullet"></button>
        <button class="ql-script" value="sub"></button>
        <button class="ql-script" value="super"></button>
        <button class="ql-indent" value="-1"></button>
        <button class="ql-indent" value="+1"></button>
        <button class="ql-direction" value="rtl"></button>
        <button class="ql-link"></button>
        <button class="ql-image"></button>
        <button class="ql-video"></button>
        <button class="ql-clean"></button>
        <!-- 字体大小 -->
        <select class="ql-size">
          <option value="small"></option>
          <option selected></option>
          <option value="large"></option>
          <option value="huge"></option>
        </select>
        <!-- 字体颜色 -->
        <select class="ql-color">
          <option value="#000000"></option>
          <option value="#e60000"></option>
          <option value="#ff9900"></option>
          <option value="#ffff00"></option>
          <option value="#008a00"></option>
          <option value="#0066cc"></option>
          <option value="#9933ff"></option>
          <option value="#ffffff"></option>
          <option value="#facccc"></option>
          <option value="#ffebcc"></option>
          <option value="#ffffcc"></option>
          <option value="#cce8cc"></option>
          <option value="#cce0f5"></option>
          <option value="#ebd6ff"></option>
          <option value="#bbbbbb"></option>
          <option value="#f06666"></option>
          <option value="#ffc266"></option>
          <option value="#ffff66"></option>
          <option value="#66b966"></option>
          <option value="#66a3e0"></option>
          <option value="#c285ff"></option>
        </select>
        <!-- 字体背景色 -->
        <select class="ql-background">
          <option value="#000000"></option>
          <option value="#e60000"></option>
          <option value="#ff9900"></option>
          <option value="#ffff00"></option>
          <option value="#008a00"></option>
          <option value="#0066cc"></option>
          <option value="#9933ff"></option>
          <option value="#ffffff"></option>
          <option value="#facccc"></option>
          <option value="#ffebcc"></option>
          <option value="#ffffcc"></option>
          <option value="#cce8cc"></option>
          <option value="#cce0f5"></option>
          <option value="#ebd6ff"></option>
          <option value="#bbbbbb"></option>
          <option value="#f06666"></option>
          <option value="#ffc266"></option>
          <option value="#ffff66"></option>
          <option value="#66b966"></option>
          <option value="#66a3e0"></option>
          <option value="#c285ff"></option>
        </select>
        <!-- 字体 -->
        <select class="ql-font">
          <option></option>
          <option value="serif"></option>
          <option value="monospace"></option>
        </select>
        <!-- h1标题 -->
        <select class="ql-header">
          <option value="1"></option>
          <option value="2"></option>
          <option value="3"></option>
          <option value="4"></option>
          <option value="5"></option>
          <option value="6"></option>
          <option value="false"></option>
        </select>
        <!-- 对齐方式 -->
        <select class="ql-align">
          <option></option>
          <option value="center"></option>
          <option value="right"></option>
          <option value="justify"></option>
        </select>
        <!-- 自定义 -->
        <el-select
          v-if="options"
          v-model="selectValue"
          placeholder="请选择"
          @change="selectChange"
          size="mini"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <!-- slot -->
        <slot></slot>
        <!-- 上传图片 -->
        <sky-upload-img
          class="upload-demo"
          :value="[]"
          bucket="iglobalwin-public-resource"
          accept="image/jpeg, image/png, image/gif"
          :limit="3"
          :multiple="false"
          :showFileList="false"
          @input="uploadInput"
        ></sky-upload-img>
      </template>
    </div>

    <quill-editor
      ref="myTextEditor"
      :value="value"
      :options="quillConfig"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
    ></quill-editor>
  </div>
</template>

<script>
import skyUploadImg from '@/components/iglobalwin/formComponents/sky-uploadimg';
import { Quill } from 'vue-quill-editor';
var Block = Quill.import('blots/block');
Block.tagName = 'DIV';

Quill.register(Block, true);
export default {
  props: ['value', 'scope', 'options'],
  data() {
    let that = this;
    return {
      quillConfig: {
        placeholder: '',
        theme: 'snow',
        modules: {
          toolbar: {
            container: '#toolbar',
            handlers: {
              image: function(value) {
                if (value) {
                  document
                    .querySelector('.upload-demo .el-upload--picture-card')
                    .click();
                } else {
                  that.$refs.myTextEditor.quill.format('image', false);
                }
              }
            }
          }
        }
      },
      selectValue: ''
    };
  },
  methods: {
    getQuill() {
      return this.$refs.myTextEditor.quill;
    },
    // 失去焦点
    onEditorBlur(event) {},
    // 富文本获得焦点时的事件
    onEditorFocus(event) {
      if (!this.scope.disabled) {
        // 解禁
        this.$refs.myTextEditor.quill.enable(true);
        // 获取焦点
        this.$refs.myTextEditor.quill.focus();
      }
    },
    // 内容改变
    onEditorChange(event) {
      // 操作DOM
      this.$nextTick(function() {
        // 禁用判断
        if (this.scope.disabled) {
          // 禁用
          this.$refs.myTextEditor.quill.enable(false);
          // 清除焦点
          this.$refs.myTextEditor.quill.blur();
        } else {
          // 解禁
          this.$refs.myTextEditor.quill.enable(true);
          // 获取焦点
          this.$refs.myTextEditor.quill.focus();
        }
      });
      // 传值
      this.scope.value = event.html;
      this.$emit('change', event);
    },
    selectChange(val) {
      if (this.scope.disabled) {
        return false;
      }
      let curTxtPoint = this.$refs.myTextEditor.quill.selection.savedRange
        .index;
      this.$refs.myTextEditor.quill.insertText(curTxtPoint, val);
    },
    uploadInput(val) {
      let that = this;
      if (val) {
        val.forEach(item => {
          // 获取焦点坐标
          let length = that.$refs.myTextEditor.quill.getSelection().index;
          // 拼接图片地址
          let imgUrl =
            'https://img.iglobalwin.com/' + encodeURIComponent(item.ossName);
          // 插入图片
          that.$refs.myTextEditor.quill.insertEmbed(length, 'image', imgUrl);
          that.$refs.myTextEditor.quill.setSelection(length + 1);
        });
      }
    }
  },
  components: { skyUploadImg }
};
</script>

<style lang="scss" scoped>
.ql-toolbar {
  line-height: 20px;
}
// 下拉框行高
.ql-size,
.ql-color,
.ql-background,
.ql-header,
.ql-font,
.ql-align {
  line-height: 20px;
}

.el-select {
  margin-left: 5px;
}

.upload-demo {
  display: none;
}

.uploadImg {
  padding: 5px;
  font-size: 14px;
  font-weight: bold;
}
</style>
